import React, { useRef } from 'react';
import Tooltip from '../../components/StepTooltip/StepTooltip';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useEvent } from '../events/event/EventProvider';
import ConnectWallet from '../events/event/mint/ConnectWallet';
import TaskCard from '../TaskCard/TaskCard';
import NftContainer from '../xion/NftContainer';
import './Identity.scss';

const IntroText = ({ user, nftProfile, isLoading }) => {
  // if (isLoading) return(<>
  //  <CardsLoader rows={1}  columns={1} columnHeight={100} />
  // </>)
  return (
    <>
      {user && nftProfile ? (
        <div className='intro-container'>
          <h2>IDENTITY RELIC WALL</h2>
          <div className='intro-text'>
            YOU CAN VIEW YOUR IDENTITY PROGRESS HERE DENOTED BY THE LEVEL OF YOUR RELIC, COMPLETE THE RITUALS TO UPGRADE IT AND MAKE YOUR IDENTITY STRONGER.
          </div>
        </div>
      ) : (
        // <Stats />
        <div className='intro-container'>
          <div className='intro-text'>
            PROOF OF IDENTITY IS MERCLE'S TAKE ON XION FOR BUILDING ON-CHAIN REPUTATION PROFILES. A STEP TOWARDS CREATING LIQUID VALUE FOR YOUR ON-CHAIN HISTORY.
          </div>
          {!user && <ConnectWallet key={'top-connect-button'} />}
        </div>
      )}
    </>
  );
};

const Identity = () => {
  const [{ event, nftProfile, campaign }] = useEvent();
  const [{ user, isLoading }] = useGlobalState();
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const steps = [
    {
      content: 'This is the identity wall.',
      targetRef: step1Ref,
    },
    {
      content: 'Here, you can view your current identity level. Since you have just started it’s at 1.',
      targetRef: step2Ref,
    },
    {
      content: 'Each lit corner represents progress. Once all four corners and the sphere atop your Identity Relic glow, you advance to the next Relic face.',
      targetRef: step3Ref,
    },
    {
      content: 'These are all the levels and their Relic faces that you get by leveling up.',
      targetRef: step4Ref,
    },
    {
      content:
        'Let’s try upgrading your level by completing this ritual, Once you have 20 XION with you, click on verify. You will notice your Relic upgrading on top, and the first corner getting lit up.',
      targetRef: step5Ref,
    },
  ];
  const handleTooltipComplete = () => {
    console.log('Tooltip flow completed!');
    localStorage.setItem(`mint_flow_steps_completed_${user.address}`, true);
  };

  const redirect = () => {
    window.open('https://mercle.xyz', '_blank');
  };

  const homePageLevelId = Object.keys(event?.eventNames)?.[0];

  return (
    <>
      <div className='center-text'>
        <div className='text'>
          {/* <p className='permissioned_text'>Permissioned Mainnet</p> */}
          <p className='profile'>
            Promethean <br /> saga <span>identity</span>{' '}
          </p>
          {/* <p className='sub-text'>
            powered by
            <MercleLogo onClick={redirect} style={{ cursor: 'pointer' }} />
            {/* <img onClick={redirect} src={require('../xion/mercle.svg')} />{' '} */}
          {/* </p> */}
        </div>
        {/* <IntroText user={user} nftProfile={nftProfile} isLoading={isLoading} /> */}
        <Tooltip steps={steps} onComplete={handleTooltipComplete} />
        <NftContainer event={event} nftProfile={nftProfile} campaign={campaign} step1={step1Ref} step2={step2Ref} step3={step3Ref} step4Ref={step4Ref} />
        {/* 
        {event &&
          nftProfile &&
          Object.keys(event.eventNames).map((levelId, i) => <TaskCard key={i} logo = {event?.eventNames[levelId]?.logo} title={event?.eventNames[levelId]?.name} levelId={levelId} event={event} stepRef={step5Ref} />) } */}
        {event  && <TaskCard event={event} stepRef={step5Ref} />}
      </div>
    </>
  );
};

export default Identity;
